import { MoveStruct } from "../utils/index.mjs";
import { bcs } from "@safecoin/safe/bcs";
//#region src/contracts/0x2/vec_set.ts
/**************************************************************
* THIS FILE IS GENERATED AND SHOULD NOT BE MANUALLY MODIFIED *
**************************************************************/
const $moduleName = "0x2::vec_set";
function VecSet(...typeParameters) {
	return new MoveStruct({
		name: `${$moduleName}::VecSet<${typeParameters[0].name}>`,
		fields: { contents: bcs.vector(typeParameters[0]) }
	});
}
//#endregion
export { VecSet };

//# sourceMappingURL=vec_set.mjs.map